export default __webpack_public_path__ + "static/media/driver.9b3ef24f.jpg";